module.exports = __webpack_public_path__ + "static/easychat-8a90c4924cc50272c19d5d733379b8b8.png";